export const CONTACT_PENDING = "CONTACT_PENDING";
export const CONTACT_SUCCESS = "CONTACT_SUCCESS";
export const CONTACT_SUCCESS_CLEAR = "CONTACT_SUCCESS_CLEAR";
export const CONTACT_ERROR_MESSAGE = "CONTACT_ERROR_MESSAGE";
export const CONTACT_ERROR_MESSAGE_CLEAR = "CONTACT_ERROR_MESSAGE_CLEAR";